import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { serverHost } from "../../../../http_common.js";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./pointOfSalesLogin.css";
import * as ActionHybrid from "../../../../store/redux/terminal_reducer.js";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import IsLoading from "../../../../IsLoading.jsx";
import AlertBar from "../../../../AlertBar.jsx";
import { usePOSTheme } from "./POSThemeSwitcher.jsx";
import "./posThemes.css";

import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { ConstructionOutlined } from "@mui/icons-material";

let itemsPayload = [],
  inventoriesPayload = [];

export default function PointOfSaleLoginX({ setTemporaryAuth }) {
  const [posTheme] = usePOSTheme();
  const [alert, setAlert] = useState(null);
  const { accessType } = useSelector((state) => state.clientFunction);
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const openRequestRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState({});
  const [currentPage, seCurrentPage] = useState("");

  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const staffData = useSelector(
    (state) => state.clientFunction?.companiesDB?.staffData,
  );

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedPin = [...pin];
    updatedPin[index] = value;

    setPin(updatedPin);

    // Move to next input
    if (value && index < pin.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Move back on delete
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };
  const {
    registerData: savedRegister,
    lastRegisterClosure,
    inventoryPOS,
    on_holded_sales,
  } = useSelector((state) => state.terminalActions);
  const [registerIdentity] = useState(() => {
    const d = new Date();
    const YY = String(d.getFullYear()).slice(-2);
    const MM = String(d.getMonth() + 1).padStart(2, "0");
    const DD = String(d.getDate()).padStart(2, "0");
    const HH = String(d.getHours()).padStart(2, "0");
    const MIN = String(d.getMinutes()).padStart(2, "0");
    const SS = String(d.getSeconds()).padStart(2, "0");
    const random =
      window.crypto?.randomUUID?.().replace(/-/g, "").slice(0, 16) ||
      Math.random().toString(36).slice(2);
    return `REG${companyData?.clientId?.slice(-7)}-${YY}${MM}${DD}-${HH}${MIN}${SS}-${random}`;
  });

  useEffect(() => {
    if (savedRegister?.requiresLogin) {
      setSelectedInventory(savedRegister.inventory || {});
      seCurrentPage("pin-page");
      setAlert({
        type: "info",
        message:
          "Verify your POS PIN to record this existing register. Your basket and held sales have been retained.",
      });
    } else if (lastRegisterClosure?.clientId === companyData?.clientId) {
      setAlert({
        type: "success",
        message: `Register ${lastRegisterClosure.registerId} closed. Sales: ${lastRegisterClosure.summary?.sales || 0}; cash sales: ${lastRegisterClosure.summary?.cash || 0}.`,
      });
    }
  }, [
    savedRegister?.requiresLogin,
    lastRegisterClosure?.registerId,
    companyData?.clientId,
  ]);

  const apiFetchItems = async () => {
    if (openRequestRef.current) return;
    if (!selectedInventory?.inventoryId || !/^\d{6}$/.test(pin.join(""))) {
      setAlert({
        type: "warning",
        message: "Select an inventory and enter your six-digit POS PIN.",
      });
      return;
    }
    if (
      (inventoryPOS?.cart?.length || on_holded_sales?.length) &&
      savedRegister?.inventory?.inventoryId !== selectedInventory.inventoryId
    ) {
      setAlert({
        type: "warning",
        message:
          "Resume the original inventory to retain your unfinished basket and held sales.",
      });
      return;
    }
    const requestRegisterId =
      savedRegister?.requiresLogin &&
      savedRegister.inventory?.inventoryId === selectedInventory.inventoryId
        ? savedRegister.registerId
        : registerIdentity;
    openRequestRef.current = true;
    setLoading(true);
    await axios
      .get(
        `${serverHost}/pointOfsale-login/fetch-inventory-items/client/${companyData?.clientId}?inventoryId=${selectedInventory?.inventoryId}&pin=${pin.join("")}&accessType=${accessType}&userId=${staffData?.userId || ""}&registerId=${encodeURIComponent(requestRegisterId)}`,
      )
      .then((response) => {
        itemsPayload = response.data?.productDB;
        if (response?.data?.status === 201) {
          if (
            itemsPayload !== undefined &&
            itemsPayload !== null &&
            response.data?.registerData?.registerId === requestRegisterId
          ) {
            dispatch(
              ActionHybrid.terminalAction({
                itemsPayload,
                registerData: response.data.registerData,
              }),
            );
            navigate(
              `/clients/point-of-sale/workspace/inventory-transactions-test`,
            );
          } else {
            setAlert({
              message:
                "Register opening could not be verified. Retry with the same register ID.",
              type: "error",
            });
          }
        } else if (response?.data?.status === 201 && itemsPayload.length == 0) {
          setAlert({
            message:
              "Your inventory is empty, please add items or products to your inventory to have access to Point of Sales",
            type: "info",
          });
        } else {
          setAlert({
            message: response.data?.message,
            type: "warning",
          });
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.code === "ERR_NETWORK") {
          setAlert({
            message: `${err.message} : please connect to the internet and try again`,
            type: "error",
          });
        } else {
          setAlert({
            message: err.response?.data?.message || err.message,
            type: "error",
          });
        }
        console.log(err?.code || "REQUEST_FAILED");
      })
      .finally(() => {
        openRequestRef.current = false;
      });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      apiFetchItems();
    }
  };

  const apiFetchInventories = async () => {
    setLoading(true);

    await axios
      .get(
        `${serverHost}/conditionalInventoryFetch/get-inventories/${companyData?.clientId}?inventoryId=${selectedInventory?.inventoryId}`,
      )
      .then((response) => {
        inventoriesPayload = response.data?.inventoriesData;
        if (response?.data?.status === 200) {
          if (inventoriesPayload !== undefined && inventoriesPayload !== null) {
            console.log("inventory Ready");
          } else {
            setAlert({
              message: response.data?.message,
              type: "error",
            });
          }
        } else if (
          response?.data?.status === 200 &&
          inventoriesPayload.length === 0
        ) {
          setAlert({
            message: "No inventories were found.",
            type: "info",
          });
        } else {
          setAlert({
            message: response.data?.message,
            type: "warning",
          });
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        if (err.code === "ERR_NETWORK") {
          setAlert({
            message: `${err.message} : please connect to the internet and try again`,
            type: "error",
          });
        } else {
          setAlert({
            message: `${err.message}`,
            type: "error",
          });
        }

        console.log(err?.code || "REQUEST_FAILED");
      });
  };

  useEffect(() => {
    if (companyData?.clientId) {
      apiFetchInventories();
    }
  }, [companyData?.clientId]);
  return (
    <div className={`pos-theme-root pos-theme-${posTheme} pos-login-theme`}>
      {alert && <AlertBar alert={alert} setAlert={setAlert} />}
      {loading && <IsLoading />}
      {currentPage === "pin-page" ? (
        <div className="pointOfSaleAuthContWrap fx-ac fx-jc pdlarge">
          <div className="pointOfSaleAuthCont fx-cl fx-ac fx-jc space2">
            <div className="fx-cl space1">
              <div className="fx-cl">
                <span>
                  <PointOfSaleIcon
                    style={{ fontSize: "5.4rem", color: "#0354d5" }}
                  />
                </span>
                <span className="fw600 fs7">Open Commerce Terminal</span>
              </div>
              <p className="fs3 lh5">
                Process customer transactions quickly and efficiently. Add
                products, apply discounts, accept multiple payment methods, and
                complete sales with a fast and seamless checkout experience.
              </p>
            </div>
            <div className="pointOfSaleAuth fx-ac fx-jc space1">
              {pin?.map((digit, index) => (
                <input
                  key={index}
                  onKeyPress={handleKeyPress}
                  type="password"
                  value={digit}
                  maxLength={1}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="pinInput"
                />
              ))}
            </div>
            <div className="fx-ac space3 fx-jc">
              <button onClick={() => seCurrentPage("")}>
                <KeyboardBackspaceIcon fontSize="large" />
              </button>
              <button disabled={loading} onClick={() => apiFetchItems()}>
                Proceed
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="pointOfSaleInventorySelection">
          <button className="closeTerminalLogin" onClick={() => window.close()}>
            <KeyboardBackspaceIcon fontSize="large" />
          </button>
          <div className="inventoriesmainCardGrid g g3 space2">
            {inventoriesPayload?.map((inventory, index) => (
              <figure
                className="inventoriesItemCard fx-cl"
                key={inventory._id || index}
              >
                <div className="rptItemCardTop fx-cl space2">
                  <span className="fs3 fw500">
                    <PointOfSaleIcon style={{ fontSize: "1.6rem" }} />
                    {inventory.inventoryName}
                  </span>

                  <div className="fx-cl spacem">
                    <div className="fx-ac space1">
                      <h3 className="fs5 fw600">{inventory.inventoryType}</h3>

                      <span className="fs1">{inventory.status}</span>
                    </div>

                    <p className="fw500" style={{ fontSize: "1.4rem" }}>
                      {inventory.description}
                    </p>
                  </div>

                  <button
                    onClick={() => {
                      setSelectedInventory(inventory);
                      seCurrentPage("pin-page");
                    }}
                  >
                    Open Inventory
                  </button>
                </div>

                <div className="rptItemCardBottom fx-cl spacem fs1">
                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>Branch ID: {inventory.branchId}</span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>Items: {inventory.statistics?.items}</span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>Categories: {inventory.statistics?.categories}</span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>
                      Transactions: {inventory.statistics?.transactions}
                    </span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>
                      Sales:{" "}
                      {inventory.settings?.allowSales ? "Enabled" : "Disabled"}
                    </span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>
                      Barcode Scanning:{" "}
                      {inventory.settings?.barcodeScanning
                        ? "Enabled"
                        : "Disabled"}
                    </span>
                  </div>

                  <div className="fx-ac spacem">
                    <CheckCircleOutlinedIcon fontSize="large" />
                    <span>
                      QR Scanning:{" "}
                      {inventory.settings?.qrScanning ? "Enabled" : "Disabled"}
                    </span>
                  </div>

                  {inventory.isDefault && (
                    <div className="fx-ac spacem">
                      <CheckCircleOutlinedIcon
                        fontSize="large"
                        style={{ color: "#22c55e" }}
                      />
                      <span>Default Inventory</span>
                    </div>
                  )}
                </div>
              </figure>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
